import { FiX } from 'react-icons/fi'
import {
  LibraryOverlay,
  OptionsModal,
  LibraryHeader,
  LibraryBody,
  OptionsSectionTitle,
  PropertyRow,
} from './canvasStyles'
import { useOverlayClose } from './useOverlayClose'

// Small settings dialog grouping the canvas "view options": the snap step used when placing/
// dragging nodes, and the visual grid/label/diagram display scales. The load/label visibility
// toggles moved to the toolbar (see StructureCanvas) since they're used often enough to want a
// single click rather than opening this modal.
const SCALE_FIELDS = [
  { key: 'deformed', label: 'Deformada' },
  { key: 'diagram', label: 'Diagramas' },
  { key: 'node', label: 'Nós' },
  { key: 'support', label: 'Apoios' },
  { key: 'text', label: 'Textos (rótulos e valores)' },
]

export function ViewOptionsPanel({
  snapSize,
  setSnapSize,
  gridSpacingX,
  setGridSpacingX,
  gridSpacingY,
  setGridSpacingY,
  viewScales,
  setViewScales,
  displacementUnit,
  setDisplacementUnit,
  onClose,
}) {
  const overlayCloseHandlers = useOverlayClose(onClose)
  return (
    <LibraryOverlay {...overlayCloseHandlers}>
      <OptionsModal onClick={(e) => e.stopPropagation()}>
        <LibraryHeader>
          <h4 style={{ margin: 0 }}>Opções de visualização</h4>
          <button type="button" onClick={onClose} title="Fechar">
            <FiX />
          </button>
        </LibraryHeader>

        <LibraryBody>
          <OptionsSectionTitle>Grade</OptionsSectionTitle>
          <PropertyRow>
            Snap (m)
            <input type="number" min={0} step={0.01} value={snapSize} onChange={(e) => setSnapSize(e.target.value)} />
          </PropertyRow>
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Passo de encaixe ao criar ou arrastar nós. Reduza para posicionar elementos pequenos (ex.: espelho de 0,17 m
            e piso de 0,30 m de uma escada).
          </p>

          <PropertyRow style={{ marginTop: '12px' }}>
            Espaçamento das linhas verticais (m)
            <input
              type="number"
              min={0}
              step={0.1}
              value={gridSpacingX}
              onChange={(e) => setGridSpacingX(e.target.value)}
            />
          </PropertyRow>
          <PropertyRow>
            Espaçamento das linhas horizontais (m)
            <input
              type="number"
              min={0}
              step={0.1}
              value={gridSpacingY}
              onChange={(e) => setGridSpacingY(e.target.value)}
            />
          </PropertyRow>
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Distância entre as linhas da grade em cada direção (independente do Snap).
          </p>

          <OptionsSectionTitle>Escalas de exibição</OptionsSectionTitle>
          {SCALE_FIELDS.map((field) => (
            <PropertyRow key={field.key}>
              {field.label} (×)
              <input
                type="number"
                min={0}
                step={0.1}
                value={viewScales[field.key]}
                onChange={(e) => setViewScales((prev) => ({ ...prev, [field.key]: e.target.value }))}
              />
            </PropertyRow>
          ))}
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Multiplicador de tamanho na tela (1 = padrão). Não altera os valores calculados, apenas a representação.
          </p>

          <OptionsSectionTitle>Deformações</OptionsSectionTitle>
          <PropertyRow>
            Unidade dos deslocamentos (u, v)
            <select value={displacementUnit} onChange={(e) => setDisplacementUnit(e.target.value)}>
              <option value="m">m</option>
              <option value="cm">cm</option>
            </select>
          </PropertyRow>
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Afeta apenas os rótulos exibidos (deslocamentos nodais, flecha máxima). Assume que as coordenadas do modelo
            estão em metros; a rotação (θ) continua em rad.
          </p>
        </LibraryBody>
      </OptionsModal>
    </LibraryOverlay>
  )
}
